import { Events } from '../events'

let socket
const socketConfig = {
  baseUrl: 'https://apis.1xpay.co',
  path: '/socket-notification/websocket/socket.io',
}

class SocketsNotifications {
  static async init() {
    try {
      socket = io.connect(socketConfig.baseUrl, {
        path: socketConfig.path,
      })
      socket.on('connected', async () => {
        SocketsNotifications.initUserTokenConnection()
      })
      socket.on('connect_error', err => {
        console.log(`connect_error due to ${err.message}`)
      })
    } catch (error) {
      console.log(error)
      return
    }
    
  }

  static setNotificationHandler(handler) {
    if (!socket) return
    socket.on('message', data => {
      console.log('received message from socket', data)
      handler(data)
    })
  }

  static async initUserTokenConnection() {
    if (!socket) return
    const deviceToken = await SocketsNotifications.getToken()
    if (!deviceToken) return
    socket.emit('deviceToken', deviceToken)
  }

  static async getToken() {
    const userData = await Events.sendDataRequestResolve('userData')
    if (!userData || !userData.reference) return ''
    const userRef = userData.reference || ''
    return `socket-token-${userRef}`
  }
}

export { SocketsNotifications }
